import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

import logo from 'assets/img/logo.png';
import Avatar from 'components/common/Avatar';
import { getText } from 'function/language';
import { useConfirmModalState } from 'global/confirmModalState';
import useLoginState from 'global/loginState';
import { ROUTER_PATH, ROUTER_NAME } from 'types/const';

/**
 * 프로필 드롭다운 메뉴
 */
const ProfileDropdown = () => {
  /* router */
  const history = useHistory();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();
  const { resetLogin } = useLoginState();

  /* event */
  // 로그아웃 클릭 시
  const onLogoutClick = () => {
    setConfirmModal({
      isOpen: true,
      title: 'logout',
      message: 'logoutMessage',
      isCancelBtn: true,
      onConfirm() {
        // 로그아웃
        resetLogin();

        // 로그인 화면 표시
        history.push(ROUTER_PATH.login);
      }
    });
  };

  /* view */
  return (
    <Dropdown as="li" navbar={true}>
      <Dropdown.Toggle
        bsPrefix="toggle"
        as="a"
        className="pe-0 nav-link cursor-pointer"
      >
        <Avatar src={logo} />
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} to={ROUTER_PATH.myPage}>
            {getText(ROUTER_NAME.myPage)}
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={onLogoutClick}>
            {getText('logout')}
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
